export default "__VITE_ASSET__BsE6MwY3__"